import { IAdminNotesResponse, IAdminPharmacyNotesResponse } from '@pharmaplan/common';

import { idStore } from '@pharmaplan/common/helpers/ServiceHandler';
import EditIcon from '../../../assets/svg/updateNoteIcon.svg';
import DeleteIcon from '../../../assets/svg/delete.svg';
import { DynamicTableCell } from '../../../helpers/Constants';
import strings from '../../../localization';
import { getDayMonthDateYear } from '../../Reports/helpers';

const { text } = DynamicTableCell;
const disableCheck = '00000000-0000-0000-0000-000000000000';

export const adminNoteHeader = () =>
  [
    { key: '0', label: strings.notes },
    {
      key: '1',
      label: strings.formatString(strings.createdFormat, strings.on) as string,
    },
    { key: '2', label: strings.action, isCenterAligned: true },
  ];

const shouldDisable = (noteId: string): boolean =>
  noteId === disableCheck;

export const notesRowConfig = (
  notes: Array<IAdminNotesResponse>,
  updateNote: (noteId: string) => () => void,
  deleteNote: (noteId: string) => () => void,
) =>
  notes?.map((item) => {
    const {
      note,
      createDate,
      adminPharmacistNoteId,
      isReadOnly,
    } = item ?? {};
    const createdParseDate = getDayMonthDateYear(createDate);

    const isLegacySystemNote = shouldDisable(adminPharmacistNoteId);
    const disabled = isLegacySystemNote || !!isReadOnly;
    const showDate = isLegacySystemNote ? '-' : createdParseDate;
    const tooltip = disabled ? strings.editNotAllowed : strings.updateNote;

    const noteId = item?.[idStore.adminClientNoteId as keyof typeof item] as string;

    return {
      key: adminPharmacistNoteId,
      data: [
        {
          key: `0-${adminPharmacistNoteId}`,
          value: note,
          type: text,
          maxWidth: 200,
        },
        {
          key: `1-${adminPharmacistNoteId}`,
          value: showDate,
          type: text,
        },
        {
          key: `2-${adminPharmacistNoteId}`,
          show: true,
          value: [
            {
              key: '1',
              icon: EditIcon,
              disabled,
              tooltip,
              onClick: updateNote(noteId),
            },
            {
              key: '2',
              icon: DeleteIcon,
              tooltip: strings.delete,
              disabled,
              onClick: deleteNote(noteId),
            },
          ],
          type: DynamicTableCell.iconButton,
        },
      ],
    };
  });

export const pharmacyNotesRowConfig = (
  notes: Array<IAdminPharmacyNotesResponse>,
  updateNote: (noteId: string) => () => void,
  deleteNote: (noteId: string) => () => void,
) =>
  notes?.map((item) => {
    const {
      note,
      createDate,
      adminPharmacyNoteId,
      isReadOnly,
    } = item ?? {};
    const createdParseDate = getDayMonthDateYear(createDate);

    const isLegacySystemNote = shouldDisable(adminPharmacyNoteId);
    const disabled = isLegacySystemNote || !!isReadOnly;
    const showDate = isLegacySystemNote ? '-' : createdParseDate;
    const tooltip = disabled ? strings.editNotAllowed : strings.updateNote;

    return {
      key: adminPharmacyNoteId,
      data: [
        {
          key: `0-${adminPharmacyNoteId}`,
          value: note,
          type: text,
          maxWidth: 200,
        },
        {
          key: `1-${adminPharmacyNoteId}`,
          value: showDate,
          type: text,
        },
        {
          key: `2-${adminPharmacyNoteId}`,
          show: true,
          value: [
            {
              key: '1',
              icon: EditIcon,
              tooltip,
              disabled,
              onClick: updateNote(adminPharmacyNoteId),
            },
            {
              key: '2',
              icon: DeleteIcon,
              tooltip: strings.delete,
              disabled,
              onClick: deleteNote(adminPharmacyNoteId),
            },
          ],
          type: DynamicTableCell.iconButton,
        },
      ],
    };
  });
